export default __webpack_public_path__ + "static/media/purchase-profile-act.2b79fef8.svg";